function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgMedicine = function SvgMedicine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      fill: "#B3E7FF"
    },
    d: "M307.3,387.764l-127.248-57.1c-18.501-8.303-29.647-26.744-28.395-46.984 c1.252-20.24,14.584-37.169,33.967-43.128l147.785-45.435c5.61-1.725,9.529-6.212,10.483-12.003c0.09-0.547,0.151-1.091,0.184-1.632 c0.194-3.186-2.714-5.729-5.823-5.004c-3.171,0.739-6.52,1.137-9.985,1.137c-19.994,0-36.202-13.142-36.202-29.353 c0-16.212,16.208-29.354,36.202-29.354c17.507,0,32.105,10.076,35.467,23.466c1.022,4.07,2.906,7.85,5.259,11.325 c6.777,10.01,9.611,22.353,7.563,34.792c-2.995,18.189-15.801,32.852-33.419,38.268l-147.785,45.435 c-9.286,2.855-10.503,11.076-10.655,13.528c-0.151,2.451,0.043,10.76,8.907,14.737l127.248,57.1 c17.951,8.055,29.121,25.965,28.46,45.629c-0.66,19.663-13.01,36.781-31.461,43.612l-129.567,47.966 c-1.895,0.702-3.836,1.035-5.744,1.035c-6.728,0-13.053-4.132-15.525-10.811c-3.174-8.573,1.203-18.096,9.776-21.269l129.567-47.966 c8.84-3.273,9.788-11.298,9.868-13.68C316.307,399.694,315.901,391.622,307.3,387.764z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#38648C"
    },
    d: "M219.636,33.477c-16.357,0-37.955-2.454-61.977-21.333c-10.06-7.907-23.123-10.912-35.679-8.448 C75.338,12.847,30.314,30.334,6.018,49.399c-18.109,14.21,4.673,43.776,68.091,13.877c-23.365,12.825,6.008,35.205,46.729,12.333 c-12.016,10.506,14.686,24.524,42.724,6.5c-8.678,14.019,23.541,28.808,48.486-7.959L219.636,33.477z"
  }), React.createElement("path", {
    style: {
      fill: "#38648C"
    },
    d: "M292.364,33.477c16.357,0,37.955-2.454,61.977-21.333c10.06-7.907,23.123-10.912,35.679-8.448 c46.642,9.151,91.665,26.638,115.962,45.704c18.109,14.21-4.673,43.776-68.091,13.877c23.365,12.825-6.008,35.205-46.729,12.333 c12.016,10.506-14.686,24.524-42.724,6.5c8.678,14.019-23.541,28.808-48.486-7.959L292.364,33.477z"
  })), React.createElement("polygon", {
    style: {
      opacity: 0.15,
      enableBackground: "new"
    },
    points: "218.002,265.232 294.785,241.626 295.953,206.633  216.859,230.949 "
  }), React.createElement("polygon", {
    style: {
      opacity: 0.15,
      enableBackground: "new"
    },
    points: "225.206,481.098 287.565,458.013 288.757,422.272 224.042,446.23  "
  }), React.createElement("path", {
    style: {
      fill: "#38648C"
    },
    d: "M284.786,91.515h-57.573l13.539,405.738C241.027,505.476,247.772,512,256,512l0,0 c8.228,0,14.973-6.524,15.247-14.747L284.786,91.515z"
  }), React.createElement("path", {
    style: {
      opacity: 0.15,
      enableBackground: "new"
    },
    d: "M228.56,131.86c8.531,3.235,17.775,5.021,27.44,5.021 c9.665,0,18.909-1.786,27.44-5.021l1.346-40.345h-57.573L228.56,131.86z"
  }), React.createElement("path", {
    style: {
      opacity: 0.15,
      enableBackground: "new"
    },
    d: "M299.953,74.15c8,11.791,16.746,18.273,24.653,21.186 c5.623-10.729,8.82-22.929,8.82-35.882c0-11.254-2.421-21.937-6.739-31.585c-12.911,4.729-24.553,5.608-34.324,5.608L299.953,74.15z "
  }), React.createElement("path", {
    style: {
      opacity: 0.15,
      enableBackground: "new"
    },
    d: "M178.574,59.454c0,12.953,3.197,25.153,8.82,35.882 c7.907-2.912,16.653-9.395,24.653-21.186l7.589-40.673c-9.771,0-21.413-0.879-34.324-5.608 C180.994,37.517,178.574,48.2,178.574,59.454z"
  }), React.createElement("circle", {
    style: {
      fill: "#38648C"
    },
    cx: 256,
    cy: 59.45,
    r: 59.45
  }), React.createElement("path", {
    style: {
      fill: "#76B7EB"
    },
    d: "M204.7,387.764l127.248-57.1c18.501-8.303,29.647-26.744,28.395-46.984 c-1.252-20.24-14.584-37.169-33.967-43.128l-147.785-45.435c-5.61-1.725-9.529-6.212-10.483-12.003 c-0.09-0.547-0.151-1.091-0.184-1.632c-0.194-3.186,2.714-5.729,5.823-5.004c3.171,0.739,6.52,1.137,9.985,1.137 c19.994,0,36.202-13.142,36.202-29.353c0-16.212-16.208-29.354-36.202-29.354c-17.507,0-32.105,10.076-35.467,23.466 c-1.022,4.07-2.906,7.85-5.259,11.325c-6.777,10.01-9.611,22.353-7.563,34.792c2.995,18.189,15.801,32.852,33.419,38.268 l147.785,45.435c9.286,2.855,10.503,11.076,10.655,13.528c0.151,2.451-0.043,10.76-8.907,14.737l-127.248,57.1 c-17.951,8.055-29.121,25.965-28.46,45.629c0.66,19.663,13.01,36.781,31.461,43.612l129.567,47.966 c1.895,0.702,3.836,1.035,5.744,1.035c6.728,0,13.053-4.132,15.525-10.811c3.174-8.573-1.203-18.096-9.776-21.269l-129.567-47.966 c-8.84-3.273-9.788-11.298-9.868-13.68C195.693,399.694,196.099,391.622,204.7,387.764z"
  }), React.createElement("polygon", {
    style: {
      opacity: 0.15,
      enableBackground: "new"
    },
    points: "290.855,349.103 292.134,312.244 220.974,344.176  222.214,379.905 "
  }), React.createElement("polygon", {
    style: {
      fill: "#38648C"
    },
    points: "274.754,392.167 277.98,295.5 234.02,295.5 237.246,392.167 "
  }), React.createElement("rect", {
    x: 180.729,
    y: 327.572,
    transform: "matrix(-0.9124 -0.4094 0.4094 -0.9124 338.1049 760.6233)",
    style: {
      fill: "#B3E7FF"
    },
    width: 139.476,
    height: 33.101
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#495059"
    },
    d: "M191.866,153.406c-4.143,0-7.5-3.357-7.5-7.5v-4.308c0-4.143,3.357-7.5,7.5-7.5s7.5,3.357,7.5,7.5 v4.308C199.366,150.049,196.009,153.406,191.866,153.406z"
  }), React.createElement("path", {
    style: {
      fill: "#495059"
    },
    d: "M320.134,153.406c-4.143,0-7.5-3.357-7.5-7.5v-4.308c0-4.143,3.357-7.5,7.5-7.5s7.5,3.357,7.5,7.5 v4.308C327.634,150.049,324.276,153.406,320.134,153.406z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMedicine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medicine.15f5ddb4.svg";
export { ForwardRef as ReactComponent };